import {
  faHeadset,
  faPalette,
  faArrowRightArrowLeft,
  faGear,
  faUser,
  faLock,
  faUsers,
  faBell,
  faPaintBrush,
  faShoppingCart,
  faEye,
  faFlag,
  faClock
} from "@fortawesome/free-solid-svg-icons";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";

const Menuitems = [
  // {
  //   title: "Dashbaord",
  //   icon: "home",
  //   href: "/",
  // },
  {
    title: "Customer Service",
    icon: faHeadset,
    href: "/customer-service",
  },
  {
    title: "TikTok",
    icon: faTiktok,
    href: "/tiktok",
  },
  {
    title: "Graphic Design",
    icon: faPalette,
    href: "/orders",
    children: [
      {
        title: "Orders",
        href: "/orders",
      },
      {
        title: "Mockups",
        href: "/mockups",
      },
      // {
      //   title: "Flag",
      //   href: "/flag",
      // },
      {
        title: "History",
        href: "/history",
      },
    ],
  },
  {
    title: "Return Requests",
    icon: faArrowRightArrowLeft,
    href: "/requests/listing",
  },
  {
    title: "Turnaround Time",
    icon: faGear,
    href: "/turnaround-time",
  },
  {
    title: "Accounts",
    icon: faUser,
    href: "/accounts",
    children: [
      {
        title: "Users",
        href: "/accounts"
      },
      {
        title: "Roles",
        href: "/roles"
      }
    ]
  },
  {
    title: "Log out",
    icon: faLock,
    href: "/logout",
  },
  // {
  //   title: "Buttons",
  //   icon: "disc",
  //   href: "/buttons",
  // },
  // {
  //   title: "Forms",
  //   icon: "layout",
  //   href: "/forms",
  // },
  // {
  //   title: "Alerts",
  //   icon: "info",
  //   href: "/alerts",
  // },
  // {
  //   title: "Ratings",
  //   icon: "star",
  //   href: "/rating",
  // },
  // {
  //   title: "Images",
  //   icon: "image",
  //   href: "/image",
  // },
  // {
  //   title: "Pagination",
  //   icon: "user",
  //   href: "/pagination",
  // },
  // {
  //   title: "Tables",
  //   icon: "grid",
  //   href: "/table",
  // },
];

export default Menuitems;
